import { Slot, AdsSlice } from 'types/State';
import { createAction, createReducer, combineReducers } from '@reduxjs/toolkit';
import * as googleAds from 'lib/GoogleAds';
import { SerializedAdConfig } from 'types/AdConfig';

const adConfigReceived = createAction<{
  adUnit: string;
  adTargeting: googleAds.Targeting;
  adsDisabled: boolean;
}>('googleAds/adConfigReceived');

const adConfigUnloaded = createAction('googleAds/adConfigUnloaded');

const slotDestructionEnqueued = createAction<Partial<SerializedAdConfig>>(
  'googleAds/slotDestructionEnqueued'
);

const slotRenderEnded = createAction<{
  elementId: string;
  isEmpty: boolean;
  isSuggestive: boolean;
}>('googleAds/slotRenderEnded');

const targetingReducer = createReducer<googleAds.Targeting>(
  {},
  {
    [adConfigReceived.type]: (state, action) => {
      return action.payload.adTargeting;
    },
    [adConfigUnloaded.type]: () => {
      return {};
    },
  }
);

const slotsReducer = createReducer<Slot[]>([], {
  [slotRenderEnded.type]: (state, action: ReturnType<typeof slotRenderEnded>) => {
    return [...state, action.payload];
  },
  [slotDestructionEnqueued.type]: (state, action) => {
    // remove the slot from the list of slots
    return state.filter((slot) => slot.elementId !== action.payload.elementId);
  },
});

const adUnitReducer = createReducer<string | null>(null, {
  [adConfigReceived.type]: (_state, action) => {
    return action.payload.adUnit;
  },
});

const googleAdsReducer = combineReducers<AdsSlice>({
  targeting: targetingReducer,
  slots: slotsReducer,
  adUnit: adUnitReducer,
});

export { googleAdsReducer, slotRenderEnded };
